import { useAuth } from "shared/contexts/Auth/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

interface Props {
  requireAuth?: boolean;
  requireVendedor?: boolean;
  requireAdmin?: boolean;
}

export const PrivateRoute: React.FC<Props> = ({
  requireAuth = true,
  requireVendedor = false,
  requireAdmin = false,
}) => {
  const { signed, loadingAuth, isVendedor, isAdmin } = useAuth();

  if (loadingAuth) {
    return <p>Carregando...</p>;
  }

  // precisa estar logado
  if (requireAuth && !signed) {
    return <Navigate to="/login" replace />;
  }

  // precisa ser vendedor
  if (requireVendedor && !isVendedor) {
    return <Navigate to="/minhaslojas" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};